"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.httpResponseSuccessHandler = void 0;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var httpResponseSuccessHandler = function (response) { return response; };
exports.httpResponseSuccessHandler = httpResponseSuccessHandler;
